import { DatePipe, formatDate } from '@angular/common';
import { Component, ElementRef, EventEmitter, Output, Renderer2, ViewChild, } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators, } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { CommonService } from 'src/app/services/common/common.service';
import { TestConstant } from 'src/app/constants/label-constants';
import { CommonConstant } from 'src/app/constants/common-constant';
import { MatDatepicker, MatDatepickerInputEvent } from '@angular/material/datepicker';
import { Observable } from 'rxjs';
import { SaveTestDialogComponent } from '../../save-test-dialog/save-test-dialog.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedService } from 'src/app/services/shared.service';
import { EncrDecrService } from 'src/app/services/EncrDecr.service';
import { StudentListComponent } from './student-list/student-list.component';

@Component({
  selector: 'app-test-add-edit',
  templateUrl: './test-add-edit.component.html',
  styleUrls: ['./test-add-edit.component.scss'],
})
export class TestAddEditComponent {
  isEditable = false;
  examDate: boolean = false;
  ZeroHourValidation: boolean = false;
  submitFirstFormButton: boolean = false;
  submitSecondFormButton: boolean = false;
  timeCheck: boolean = false;
  totalQuestionCheck: boolean = false;
  cutoffCheck: boolean = false;
  DateNow: any;
  now: any;
  now1: any;
  isShown: boolean = false;
  testDuration: any;
  formTestDuration: any;
  questionSetList: any = [];
  dropdownQuestionSetSettings: any = {};
  selectedQuestionSetItems: any = [];
  questionSetLabel: any = [];
  uniqueIdForqSet: number = 0;
  totalQuestions: number = 0;
  @ViewChild('mydivCollege') mydivCollege!: ElementRef;
  collegeList: any = [];
  selectedCollege: any = [];
  collegeBatchList: any = [];
  collegeId: number = 0;
  CollegeBatchSettings = {};
  selectedCollegebatchItems: Array<any> = [];
  selectedBatchData: any = {};
  finalSelectedBaches: any = [];
  finalBaches: any = [];
  TestConstant: any = [];
  questionSetArray: any = [];
  CommonConstant: any = [];
  batchIds: any = [];
  Hours: any;
  Minutes: any;
  student: any;
  batchText: any;
  batchText1: any;
  totalstudent: number = 0;
  CutOff: any;
  selectedDate: any;
  formattedDate: any;
  enterSearch: any;
  IsQuestionSetSelected: boolean = true;
  SearchCollege: any = '';
  SearchedCollege: any;
  selectedAllBatch: any = [];
  collegeIds: any;
  MainCollegeDiv: boolean = false;
  batchDiv: boolean = false;
  // Edit Properties Below
  EditId: any = 0;
  EditExamData: any;
  ExamSelectedBatches: any = [];
  optionCheckItem: FormArray<any> | undefined;
  ZeroValForNext: boolean = false;
  //New Variable For Difference For Setting Duration 23/08/2023
  checked: boolean = false;
  MaximumHourExamDuration: number = 0;
  MaximumMinuteExamDuration: number = 0;
  MaxMinuteError: boolean = false;
  MaxHourError: boolean = false;
  MaxDurationExanInMilliSecond: number = 0;
  IsDateSelected: boolean = false;
  IsTimeValidToSubmit: boolean = true;
  isTimeSelected: boolean = true;
  SaveTestObj: any = {};
  CutOffFlag: boolean = false;
  MinutesVaidation: any;
  collegeNotFound: boolean = false;
  SelectedCollegeDataList: any = [];
  SelectedCollegeId: any = []
  selectedDate1: any;
  selectedTime: any;
  currentDate: any;
  minTime: any;
  strTime: any;
  ParagraphNote: boolean = false;
  @ViewChild('yourDropdown') yourDropdown: any;
  @ViewChild('collegeBatchSelect') collegeBatchSelect: any;
  @ViewChild('CutOff') cutOffInput: ElementRef | any;
  @ViewChild('picker') picker!: MatDatepicker<Date>;
  @Output()
  dateChange: EventEmitter<MatDatepickerInputEvent<any>> = new EventEmitter();
  constructor(
    private _formBuilder: FormBuilder,
    private toastr: ToastrService,
    private apiUrl: ApiUrlHelper,
    public commonService: CommonService,
    private spinner: NgxSpinnerService,
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private route: Router,
    private router: ActivatedRoute,
    private modalService: NgbModal,
    private sharedService: SharedService,
    private EncrDecr: EncrDecrService
  ) {

    //  this.currentDate = formatDate(new Date(), 'dd/MM/yyyy', 'en');
    this.currentDate = new Date();
    const currentDate = new Date();
    this.formatAMPM(currentDate);


    // Get EditId
    // var decrypted = params['id'] ? params['id'] : '';
    var encryptedId = this.router.snapshot.paramMap.get("id");
    var decryptedId = encryptedId ? decodeURIComponent(encryptedId) : "0";
    this.EditId = Number(this.EncrDecr.get('123456$#@$^@1ERF', decryptedId));
    this.sharedService.setData('Add Exam');
    if (this.EditId > 0) {
      this.sharedService.setData('Update Exam');
    }
  }

  minArrayLength(minLength: number) {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const formArray = control as FormArray;
      if (formArray.length >= minLength) {
        return null;
      } else {
        return { minArrayLength: { requiredLength: minLength, actualLength: formArray.length } };
      }
    };
  }


  async ngOnInit() {
    this.DateNow = new Date();
    this.now1 = (this.DateNow.getHours() + 24) % 12 || 12;
    this.TestConstant = TestConstant;
    this.CommonConstant = CommonConstant;
    this.secondFormGroup = new FormGroup({
      questionSet: this._formBuilder.array([], this.minArrayLength(1)),
    });

    this.getQuestionSetList();

    const datePipe = new DatePipe('en-Us');
    this.now = datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.dropdownQuestionSetSettings = {
      idField: 'questionSetId',
      textField: 'examQuestionSet',
      singleSelection: false,
      enableCheckAll: false,
      allowSearchFilter: true,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search Question Set Type',
      showSelectedItemsAtTop: false,
      totalQuestionsField: 'totalQuestions',
    };
    this.CollegeBatchSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      enableCheckAll: false,
      itemsShowLimit: 0,
      allowSearchFilter: true,
    };
    this.getCollegeList().then(collegeList => {
      if (this.EditId > 0) {

        this.GetTestData(this.EditId)
        this.IsTimeValidToSubmit = false;
        this.timeCheck = false;
      }
      else {
        this.EditId = 0;
      }  // Use the collegeList here
    }).catch(error => {
      console.log('Error in college list get');

      // Handle errors here
    });


  }
  firstFormGroup: FormGroup = this._formBuilder.group({
    TestName: ['', Validators.required],
    Date: ['', Validators.required],
    StartTime: ['', Validators.required],
    EndTime: ['', Validators.required],
    Hours: ['', Validators.required],
    Minutes: ['', Validators.required]
  });
  secondFormGroup: FormGroup = this._formBuilder.group({
    CutOff: ['', Validators.required],
  });
  thirdFormGroup: FormGroup = this._formBuilder.group({
    TotalCollge: [0, Validators.min(1)]
  });
  fourthFormGroup: FormGroup = this._formBuilder.group({
    CollegeId: ['']
  });

  get firstFormControl() {
    return this.firstFormGroup.controls;
  }
  get secondFormControl() {
    return this.secondFormGroup.controls;
  }
  onDateSelection(date: any) {
  }
  public onDateChange(): void {
    this.dateChange.emit();
  }

  openDatepicker() {
    this.picker.open();
  }


  submitFirstForm() {

    this.MinutesVaidation = this.firstFormGroup.value.Minutes;
    const dayNames = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
    const monthNames = [
      'JAN',
      'FEB',
      'MAR',
      'APR',
      'MAY',
      'JUN',
      'JUL',
      'AUG',
      'SEP',
      'OCT',
      'NOV',
      'DEC',
    ];
    if (!this.firstFormGroup.valid) {
      this.submitFirstFormButton = true;
      return;
    }
    if (this.firstFormGroup.valid) {
      if (this.MaxMinuteError || this.MaxHourError) {
        // this.firstFormGroup.invalid;
        this.timeCheck = false;
        return;
      }
      else {
        this.timeCheck = false;
        this.isShown = true;
      }
    }

    let d = moment.duration(this.testDuration);
    this.Hours = Math.floor(d.asHours());
    this.Minutes = moment.utc(this.testDuration).format('mm');
    this.formTestDuration =
      Math.floor(d.asHours()) + moment.utc(this.testDuration).format(':mm');
    this.selectedDate = this.firstFormGroup.value.Date;
    this.formattedDate = `${dayNames[this.selectedDate.getDay()]} {monthNames[this.selectedDate.getMonth()]
      } ${this.selectedDate.getDate()} ${this.selectedDate.getFullYear()}`;


    const currentDate = new Date();
    this.formatAMPM(currentDate);



    if (!this.selectedDate || !this.selectedTime) {
      return;
    }

    const selectedDateTime = new Date(this.selectedDate1);


  }
  formatAMPM(currentDate) {
    var hours = currentDate.getHours();
    var minutes = currentDate.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    this.strTime = hours + ':' + minutes + ' ' + ampm;
  }
  submitSecondForm() {
    if (
      this.CutOff === 0 ||
      this.CutOff == undefined ||
      this.CutOff == null ||
      this.CutOff == ''
    ) {
      this.toastr.error('Passing marks cannot be less than or equal to 0');
      this.totalQuestionCheck = false;

      return;
    }
    if (this.CutOff >= this.totalQuestions) {
      this.toastr.error(
        'Passing Marks Cannot Be More Than Total Question Marks'
      );
      this.totalQuestionCheck = false;
      return;
    }
    if (!this.secondFormGroup.valid && this.totalQuestions <= this.CutOff) {
      this.totalQuestionCheck = true;

    }
  }

  getDataDiff(startDate, endDate) {
    var diff = endDate.getTime() - startDate.getTime();
    var days = Math.floor(diff / (60 * 60 * 24 * 1000));
    var hours = Math.floor(diff / (60 * 60 * 1000)) - days * 24;
    var minutes =
      Math.floor(diff / (60 * 1000)) - (days * 24 * 60 + hours * 60);
    var seconds =
      Math.floor(diff / 1000) -
      (days * 24 * 60 * 60 + hours * 60 * 60 + minutes * 60);
    return { day: days, hour: hours, minute: minutes, second: seconds };
  }

  convertInto24TimeFormat(timeString: string) {
    const [time, period] = timeString.split(' ');
    const [hours, minutes] = time.split(':');
    let convertedHours = parseInt(hours, 10);
    if (period === 'PM' && convertedHours !== 12) {
      convertedHours += 12;
    } else if (period === 'AM' && convertedHours === 12) {
      convertedHours = 0;
    }
    const formattedTime = `${convertedHours.toString().padStart(2, '0')}:${minutes}`;
    return formattedTime;
  }

  ValidTimeDuration() {
    this.validHourForExamDuration(this.firstFormGroup.value.Hours);
    this.validMinuteForExamDuration(this.firstFormGroup.value.Minutes);
  }

  ValidHourMinuteDuration() {
    if (this.firstFormGroup.value.Hours == 0 && this.firstFormGroup.value.Minutes == 0) {
      this.ZeroHourValidation = true;
      this.ZeroValForNext = true;
    }
    else {
      this.ZeroHourValidation = false;
      this.ZeroValForNext = false;
    }
    if (Number.isNaN(this.firstFormGroup.value.Hours)) {
      return;
    }
    if (Number.isNaN(this.firstFormGroup.value.Minutes) || this.firstFormGroup.value.Minutes == '') {
      return;
    }
    var InputHourInMillisecond = parseInt(this.firstFormGroup.value.Hours) * 3600000;
    var InputMinuteInMillisecond = parseInt(this.firstFormGroup.value.Minutes) * 60000;
    var totalMilliSecond = InputHourInMillisecond + InputMinuteInMillisecond;
    if (totalMilliSecond <= this.testDuration) {
      this.MaxHourError = false;
      this.MaxMinuteError = false;
      this.IsTimeValidToSubmit = false;
    }
    else {
      this.toastr.error("Hour and minutes are not in exam duration limit");
      this.IsTimeValidToSubmit = true;
    }
  }

  async validHourForExamDuration(event: any) {
    var InputMinuteInMillisecond = parseInt(this.firstFormGroup.value.Minutes) * 60000;
    if (Number.isNaN(InputMinuteInMillisecond)) {
      this.MaxDurationExanInMilliSecond = this.testDuration - 0;
    }
    else {
      this.MaxDurationExanInMilliSecond = this.testDuration - InputMinuteInMillisecond;
    }
    if (typeof (event) == "number") {
      var inputHour = event;
    }
    // else {
    //   var inputHour = parseInt(event.target.value);
    // }
    else if (event != "") {
      var inputHour = parseInt(event.target.value);
    }
    else {
      var inputHour = 0;
    }
    if (Number.isNaN(inputHour)) {
      inputHour = 0;
    }
    inputHour = inputHour * 3600000;
    if (this.MaxDurationExanInMilliSecond < inputHour) {
      this.IsTimeValidToSubmit = true;
      this.MaxHourError = true;
    }
    else {
      this.MaxDurationExanInMilliSecond = this.MaxDurationExanInMilliSecond - inputHour;
      this.IsTimeValidToSubmit = false;
      this.MaxHourError = false;
    }
  }

  async validMinuteForExamDuration(event: any) {
    if (this.firstFormGroup.value.Hours == 0 && this.firstFormGroup.value.Minutes == 0) {
      this.ZeroHourValidation = true;
      this.ZeroValForNext = true;
    }
    else {
      this.ZeroHourValidation = false;
      this.ZeroValForNext = false;
    }
    var InputHourInMillisecond = parseInt(this.firstFormGroup.value.Hours) * 3600000;
    if (Number.isNaN(InputHourInMillisecond)) {
      this.MaxDurationExanInMilliSecond = this.testDuration - 0;
    }
    else {
      this.MaxDurationExanInMilliSecond = this.testDuration - InputHourInMillisecond;
    }
    if (typeof (event) == "number") {
      var inputMinute = event;
    }
    // else {
    //   var inputMinute = parseInt(event.target.value);
    // }
    else if (event != "") {
      var inputMinute = parseInt(event.target.value);
    }
    else {
      var inputMinute = 0;
    }
    if (Number.isNaN(inputMinute)) {
      inputMinute = 0;
    }
    inputMinute = inputMinute * 60000;
    if (this.MaxDurationExanInMilliSecond < inputMinute) {
      this.IsTimeValidToSubmit = true;
      this.MaxMinuteError = true;
    }
    else {
      this.MaxDurationExanInMilliSecond = this.MaxDurationExanInMilliSecond - inputMinute;
      this.IsTimeValidToSubmit = false
      this.MaxMinuteError = false;
    }
  }

  async onEndTimeSelected(event: any) {
    var inputHour = parseInt(this.firstFormGroup.value.Hours);
    if (Number.isNaN(inputHour)) {
      inputHour = 0;
    }
    inputHour = inputHour * 3600000;
    if (this.MaxDurationExanInMilliSecond < inputHour) {
      this.IsTimeValidToSubmit = true;
      this.MaxHourError = true;
    }
    else {
      this.MaxDurationExanInMilliSecond = this.MaxDurationExanInMilliSecond - inputHour;
      this.IsTimeValidToSubmit = false;
      this.MaxHourError = false;
    }
    var inputMinute = parseInt(this.firstFormGroup.value.Minutes);
    if (Number.isNaN(inputMinute)) {
      inputMinute = 0;
    }
    inputMinute = inputMinute * 60000;
    if (this.MaxDurationExanInMilliSecond < inputMinute) {
      this.IsTimeValidToSubmit = true;
      this.MaxMinuteError = true;
    }
    else {
      this.MaxDurationExanInMilliSecond = this.MaxDurationExanInMilliSecond - inputMinute;
      this.IsTimeValidToSubmit = false
      this.MaxMinuteError = false;
    }

    const endtimeStringIn24HourFormat = this.convertInto24TimeFormat(event);
    const selectedStartDateTime = await this.createDateTimeFromFormValues(
      this.firstFormGroup.value.StartTime
    );
    const selectedEndDateTime = await this.createDateTimeFromFormValues(endtimeStringIn24HourFormat);
    this.timeCheck = selectedStartDateTime >= selectedEndDateTime;
    if (!this.timeCheck) {
      await this.updateTestDuration(selectedStartDateTime, selectedEndDateTime);
    }
  }

  async onStartTimeSelected(event: string) {
    var inputHour = parseInt(this.firstFormGroup.value.Hours);
    if (Number.isNaN(inputHour)) {
      inputHour = 0;
    }
    inputHour = inputHour * 3600000;
    if (this.MaxDurationExanInMilliSecond < inputHour) {
      this.IsTimeValidToSubmit = true;
      this.MaxHourError = true;
    }
    else {
      this.MaxDurationExanInMilliSecond = this.MaxDurationExanInMilliSecond - inputHour;
      this.IsTimeValidToSubmit = false;
      this.MaxHourError = false;
    }
    var inputMinute = parseInt(this.firstFormGroup.value.Minutes);
    if (Number.isNaN(inputMinute)) {
      inputMinute = 0;
    }
    inputMinute = inputMinute * 60000;
    if (this.MaxDurationExanInMilliSecond < inputMinute) {
      this.IsTimeValidToSubmit = true;
      this.MaxMinuteError = true;
    }
    else {
      this.MaxDurationExanInMilliSecond = this.MaxDurationExanInMilliSecond - inputMinute;
      this.IsTimeValidToSubmit = false
      this.MaxMinuteError = false;
    }
    const starttimeStringIn24HourFormat = this.convertInto24TimeFormat(event);
    const selectedEndDateTime = await this.createDateTimeFromFormValues(
      this.firstFormGroup.value.EndTime
    );

    const selectedStartDateTime = await this.createDateTimeFromFormValues(starttimeStringIn24HourFormat);
    this.timeCheck = selectedStartDateTime >= selectedEndDateTime;
    if (!this.timeCheck) {
      await this.updateTestDuration(selectedStartDateTime, selectedEndDateTime);
    }
  }

  async updateTestDuration(startTime: moment.Moment, endTime: moment.Moment) {
    this.isTimeSelected = false;
    this.testDuration = Math.abs((startTime.diff(endTime)));
    const duration = moment.duration(this.testDuration);
    this.Hours = Math.floor(duration.asHours());
    this.Minutes = duration.minutes();
    this.formTestDuration = `${this.Hours}:${this.Minutes}`;
    this.MaxDurationExanInMilliSecond = this.testDuration;
    this.ValidTimeDuration();
  }

  async createDateTimeFromFormValues(timeValue: string): Promise<moment.Moment> {
    var selectedDate = moment(this.firstFormGroup.value.Date).format(
      'YYYY-MM-DD'
    );
    const timeIn24HrFormat = this.convertInto24TimeFormat(timeValue);
    return moment(`${selectedDate} ${timeIn24HrFormat}`, 'YYYY-MM-DD HH:mm');
  }

  minFromMidnight(tm: any) {
    var ampm = tm.substr(-2);
    var clk = tm.substr(0, 5);
    var min = parseInt(clk.match(/\d+$/)[0], 10);
    var hour = parseInt(clk.match(/^\d+/)[0], 10);
    hour += ampm.match(/pm/i) ? 12 : 0;
    return hour * 60 + min;
  }
  async getQuestionSetList() {
    const apiUrl = this.apiUrl.apiUrl.test.GetQuestionSetList;
    this.commonService
      .doGet(apiUrl)
      .pipe()
      .subscribe({
        next: (data) => {
          if (data && data.data && data.data.length > 0) {
            this.questionSetList = data.data;
          }
        },
        error: (err) => {

        }
      });
  }
  //Get Question Set type
  async getCollegeList(): Promise<Observable<any>> {
    return new Promise(async (resolve, reject) => {
      this.spinner.show();
      const apiUrl = this.apiUrl.apiUrl.college.GetCollegeListForExam;
      var SearchModel = {
        filter: this.SearchCollege
      };
      (await this.commonService
        .doPost(apiUrl, SearchModel))
        .pipe()
        .subscribe({
          next: async (data) => {
            this.spinner.hide();

            if (data && data.data && data.data.length > 0) {
              this.collegeList = data.data;
              this.filterArrayList = data.data

              resolve(this.collegeList);
            }
          },
          error: (err) => {
          }
        });

    })

  }
  get questionSet(): FormArray {
    return this.secondFormGroup.get('questionSet') as FormArray;
  }

  onItemSelectQuestionSet(item: any) {
    let QuestionSetName = this.questionSetList.filter(obj => {
      return obj.examQuestionSet == item.examQuestionSet
    })[0].questionSetName;
    this.ParagraphNote = true;
    // if (QuestionSetName == 'Paragraph') {
    //   this.ParagraphNote = true;
    // }
    // else {
    //   this.ParagraphNote = true;
    // }
    this.questionSetLabel.push({
      id: this.uniqueIdForqSet,
      labels: item.examQuestionSet,
      questionSetName: QuestionSetName
    });
    this.uniqueIdForqSet++;
    this.questionSet.push(
      new FormGroup({
        numberOfQuestion: new FormControl('', [Validators.required, Validators.min(1)]),
      })
    );
    if (this.questionSet.length > 0) {
      this.IsQuestionSetSelected = false;
    } else {
      this.IsQuestionSetSelected = true;
    }
  }

  onItemDeSelectQuestionSet(item: any, event?: any) {
    const control = <FormArray>this.secondFormGroup.controls['questionSet'];
    let codeLength = this.secondFormGroup.value.questionSet
      ? this.secondFormGroup.value.questionSet.length
      : 0;
    if (codeLength > 0) {
      this.uniqueIdForqSet--;
      const labelIndex = this.questionSetLabel.findIndex(
        (element) => element.labels === item.examQuestionSet
      );
      if (labelIndex !== -1) {
        this.questionSetLabel.splice(labelIndex, 1);
        if (item.examQuestionSet.replace(/\(\d+\)/g, '') == 'Paragraph') {
          this.totalQuestions -= control.value[labelIndex].numberOfQuestion * 5;
        }
        else {
          this.totalQuestions -= control.value[labelIndex].numberOfQuestion;
        }

        this.uniqueIdForqSet--;

        if (this.questionSet.length > 0) {
          this.IsQuestionSetSelected = false;
        } else {
          this.IsQuestionSetSelected = true;
        }
        control.removeAt(labelIndex);
      }
      if (this.totalQuestions <= this.CutOff) {
        this.GetCutOff(this.CutOff);
      }
    }
  }

  onSelectAllQuestionSet(item: any) {
    this.onUnSelectAllQuestionSet();
    for (let i = 0; i < item.length; i++) {
      this.questionSetLabel.push({
        id: this.uniqueIdForqSet,
        labels: item[i].examQuestionSet,
      });
      this.questionSet.push(
        new FormGroup({
          numberOfQuestion: new FormControl('', [Validators.required]),
        })
      );
    }
    if (this.questionSet.length > 0) {
      this.IsQuestionSetSelected = false;
    } else {
      this.IsQuestionSetSelected = true;
    }
  }

  onUnSelectAllQuestionSet() {
    this.questionSetLabel = [];
    const control = this.secondFormGroup.get('questionSet') as FormArray;
    const codeLength = control.length;
    if (codeLength > 0) {
      for (let i = codeLength - 1; i >= 0; i--) {
        control.removeAt(i);
        this.uniqueIdForqSet--;
      }
    }
    if (this.questionSet.length > 0) {
      this.IsQuestionSetSelected = false;
    } else {
      this.IsQuestionSetSelected = true;
    }
  }

  removeQuestionSet(i: any) {
    const selectedIndex = this.selectedQuestionSetItems.findIndex(
      (selectedItem) => selectedItem.examQuestionSet === i
    );
    if (selectedIndex > -1) {
      this.selectedQuestionSetItems.splice(selectedIndex, 1);
      this.selectedQuestionSetItems = [...this.selectedQuestionSetItems];
    }

    const control = this.secondFormGroup.get('questionSet') as FormArray;
    var value = control.value[selectedIndex];
    value = Number.parseInt(value.numberOfQuestion);
    if (value == '' || Number.isNaN(value)) {
      value = 0;
    }
    if (i.replace(/\(\d+\)/g, '') == 'Paragraph') {
      this.totalQuestions -= value * 5;
    }
    else {
      this.totalQuestions -= value;
    }

    control.removeAt(selectedIndex);
    this.questionSetLabel.splice(selectedIndex, 1);
    this.uniqueIdForqSet--;

    if (this.questionSet.length > 0) {
      this.IsQuestionSetSelected = false;
    } else {
      this.IsQuestionSetSelected = true;
    }
    if (this.totalQuestions <= this.CutOff) {
      this.GetCutOff(this.CutOff);
    }
  }

  onInputKeyUp(event: any, i) {
    const totalQuestion =
      this.questionSetList[
        this.questionSetList.findIndex(
          (selectedItem) => selectedItem.examQuestionSet === i
        )
      ].totalQuestions;


    if (totalQuestion < event.target.value) {
      this.toastr.error(
        "Question can't be more than total questions from Question Set"
      );
    }
    let flaseFlag = true;
    for (let i = 0; i < this.questionSetLabel.length; i++) {
      if (this.questionSetList[this.questionSetList.findIndex((selectedItem) => selectedItem.examQuestionSet === this.questionSetLabel[i].labels)].totalQuestions < this.secondFormGroup.value.questionSet[i].numberOfQuestion) {
        flaseFlag = false;
        break;
      }
    }
    if (flaseFlag) {
      this.totalQuestionCheck = true;
    } else {
      this.totalQuestionCheck = false;
    }

  }
  focusOutFunction(event: any, label: string) {
    this.totalQuestions = 0;

    for (let i = 0; i < this.questionSetLabel.length; i++) {
      if (this.questionSetLabel[i].labels.includes('Paragraph')) {
        this.totalQuestions += (Number(this.secondFormGroup.value.questionSet[i].numberOfQuestion) * 5);
      }
      else {
        this.totalQuestions += Number(this.secondFormGroup.value.questionSet[i].numberOfQuestion);
      }
    }

    if (this.secondFormGroup.valid && !(this.CutOff === 0 ||
      this.CutOff == undefined ||
      Number.isNaN(this.CutOff) ||
      this.CutOff == null ||
      this.CutOff == '')) {
      this.GetCutOff(this.CutOff);
    }
  }

  clearAll() {

    for (let index = 0; index < this.questionSet.controls.length; index++) {
      this.questionSet.controls[index].setValue({
        numberOfQuestion: ''
      })
    }
    this.cutoffCheck = false;
    this.totalQuestions = 0;
    this.CutOff = 0;
    this.updateCutOffValue(this.CutOff);
  }
  deleteAll() {
    this.onUnSelectAllQuestionSet();
    this.selectedQuestionSetItems = [];
    this.questionSet.reset();
    this.totalQuestions = 0;
    this.CutOff = 0;
    this.updateCutOffValue(this.CutOff);
  }
  handleImageError(event: any) {
    event.target.src = '../../../assets/img/default_college.png';
    // Replace with the path to your placeholder image
    event.onerror = null;
  }
  oncollegeListCheckboxChange(e: any, ind: number) {
    let value = parseInt(this.thirdFormGroup.value.TotalCollge);
    this.collegeList[ind].checked = e.target.checked;
    if (e.target.checked == true) {
      this.SelectedCollegeId.push(this.collegeList[ind].id);
      this.thirdFormGroup.setValue({
        TotalCollge: value + 1
      });
    }
    else {
      let arrayIndex = this.SelectedCollegeId.indexOf(this.collegeList[ind].id);
      if (arrayIndex >= 0) {
        this.SelectedCollegeId.splice(arrayIndex, 1);
      }
      this.thirdFormGroup.setValue({
        TotalCollge: value - 1
      });
    }
  }
  bindSelectedCollegeFlag() {
    let isCheckedArry = this.collegeList.filter((x: any) => x.checked == true);
    // this.selectedCollege = isCheckedArry;
    // this.bindSelectedCollege()
    return isCheckedArry.length > 0 ? true : false;
  }
  bindSelectedCollege() {

    let isCheckedArry = this.collegeList.filter((x: any) => x.checked == true);
    this.selectedCollege = isCheckedArry;
    if (this.SelectedCollegeDataList.length > 0) {
      for (let i = 0; i < this.SelectedCollegeDataList.length; i++) {
        var index = this.selectedCollege.findIndex(object => object.id == this.SelectedCollegeDataList[i].collegeId);
        if (index < 0) {
          this.onCloseCollegeDiv(this.SelectedCollegeDataList[i].collegeId)
        }
      }
    }


  }
  onChangeCollege(e: any) {
    this.spinner.show();
    this.collegeBatchList = [];
    if (e == "") {
      this.spinner.hide();
      this.collegeBatchSelect.data = [];
      return;
    }
    this.collegeId = e;

    if (
      this.finalSelectedBaches.findIndex((x) => x.collegeId == this.collegeId) <
      0
    ) {
      this.finalSelectedBaches.push({ collegeId: this.collegeId, batchs: [] });
      var length = this.finalSelectedBaches[0].batchs.length;
    }

    const apiUrl =
      this.apiUrl.apiUrl.collageBatch.GetCollegeBatchListWithStudent.replace(
        '{id}',
        this.collegeId.toString()
      );
    this.commonService
      .doGet(apiUrl)
      .pipe()
      .subscribe({
        next: (data) => {
          this.spinner.hide();
          if (data && data.data && data.data.length > 0) {
            for (let i = 0; i < data.data.length; i++) {
              const itemText = `${data.data[i].batchName}(${data.data[i].totalStudents})`;
              this.collegeBatchList.push({
                item_id: data.data[i].collegeBatchId,
                item_text: itemText,
                collegeId: e,
                Checked: false,
                totalStudents: data.data[i].totalStudents
              });
            }
            if (this.collegeBatchSelect)
              this.collegeBatchSelect.data = this.collegeBatchList;
          }
        },
        error: (err) => {
          this.spinner.hide();
        },
      });

    let collegeDivExist = 0;
    let CollegeData = this.collegeList[this.collegeList.findIndex(x => x.id === Number(e))]
    if (this.SelectedCollegeDataList.length > 0) {
      let collegedata = this.SelectedCollegeDataList.filter(x => x.collegeId == e);
      if (collegedata.length > 0)
        console.log("");
      else {
        let newCollegeDivData = {
          collegeName: CollegeData.collegeName,
          city: CollegeData.city,
          state: CollegeData.state,
          collegeUrl: CollegeData.collegeUrl
        }
        this.SelectedCollegeDataList.push({ collegeId: e, CollegeData: newCollegeDivData, Batches: [] })
      }
    }
    else {

      // this.
      let newCollegeDivData = {
        collegeName: CollegeData.collegeName,
        city: CollegeData.city,
        state: CollegeData.state,
        collegeUrl: CollegeData.collegeUrl
      }

      this.SelectedCollegeDataList.push({ collegeId: e, CollegeData: newCollegeDivData, Batches: [] })
    }

  }

  GetSubstringByString(a: any, b: any, c: any) {
    return c.Substring(
      c.IndexOf(a) + a.Length,
      c.IndexOf(b) - c.IndexOf(a) - a.Length
    );
  }

  onSelectCollegebatch1(item: any) {
    let collegeId = this.collegeBatchList[this.collegeBatchList.findIndex(selectedItem => selectedItem.item_text === item.item_text)].collegeId;
    let batchData = this.collegeBatchList.filter(x => x.item_id == item.item_id);

    if (this.SelectedCollegeDataList.length > 0) {
      let CollegeBatchData = this.SelectedCollegeDataList.filter(x => x.collegeId == collegeId);
      if (CollegeBatchData && CollegeBatchData[0].Batches.length > 0) {
        let checkBatchIsExist = CollegeBatchData[0].Batches.filter(x => x.BatchId == item.item_id)
        if (checkBatchIsExist.length == 0) {
          CollegeBatchData[0].Batches.push({ BatchId: item.item_id, BatchName: item.item_text, totalStudent: batchData[0].totalStudents });
        }
      }
      else {
        CollegeBatchData[0].Batches.push({ BatchId: item.item_id, BatchName: item.item_text, totalStudent: batchData[0].totalStudents });
      }
    }
    this.totalstudent = this.totalstudent + batchData[0].totalStudents;

  }

  onSelectAllCollegeBatch(item: any) {
    for (let i = 0; i < item.length; i++) {
      let batchData = this.collegeBatchList.filter(x => x.item_id == item[i].item_id);
      let collegeId = this.collegeBatchList[this.collegeBatchList.findIndex(selectedItem => selectedItem.item_text === item[i].item_text)].collegeId;
      let collegeindex = this.SelectedCollegeDataList.findIndex(x => x.collegeId == collegeId);

      if (this.SelectedCollegeDataList.length > 0) {
        let CollegeBatchData = this.SelectedCollegeDataList.filter(x => x.collegeId == collegeId);
        if (CollegeBatchData[0].Batches.length > 0) {
          let checkBatchIsExist = CollegeBatchData[0].Batches.filter(x => x.BatchId == item[i].item_id)
          if (checkBatchIsExist.length == 0) {
            this.SelectedCollegeDataList[collegeindex].Batches.push({ BatchId: item[i].item_id, BatchName: item[i].item_text, totalStudent: batchData[0].totalStudents });
          }
        }
        else {
          CollegeBatchData[0].Batches.push({ BatchId: item[i].item_id, BatchName: item[i].item_text, totalStudent: batchData[0].totalStudents });
        }
        this.totalstudent = this.totalstudent + batchData[0].totalStudents;
      }
    }
  }

  onDeSelectAllBatch1(item: any) {
    let collegeindex = this.SelectedCollegeDataList.findIndex(x => x.collegeId == this.collegeId);
    this.SelectedCollegeDataList[collegeindex].Batches = [];
    this.checked = false;
  }

  onDeSelectBatch1(item: any) {
    let collegeId = this.collegeBatchList[this.collegeBatchList.findIndex(selectedItem => selectedItem.item_text === item.item_text)].collegeId;
    this.onDeSelectBatch(item.item_id, collegeId);
  }

  onDeSelectBatch(batchId: number, CollegeId: number) {
    let collegeData = this.SelectedCollegeDataList.filter(x => x.collegeId == CollegeId);
    let collegeindex = this.SelectedCollegeDataList.findIndex(x => x.collegeId == CollegeId);
    if (collegeData && collegeData.length > 0) {
      let index = collegeData[0].Batches.findIndex(x => x.BatchId == batchId);
      let totalStudents = this.SelectedCollegeDataList[collegeindex].Batches[index].totalStudent;
      this.SelectedCollegeDataList[collegeindex].Batches.splice(index, 1);
      this.totalstudent = this.totalstudent - totalStudents;
    }
    for (let i = 0; i < this.SelectedCollegeDataList.length; i++) {
      this.SelectedCollegeDataList[i].Batches.forEach((element, index) => {
        if (element.BatchId == batchId)
          this.SelectedCollegeDataList[i].Batches.splice(index, 1);
      });
    }

    const selectedItem = this.collegeBatchSelect.selectedItems.findIndex(item => item.id === batchId);
    if (selectedItem != -1) {
      this.collegeBatchSelect.selectedItems.splice(selectedItem, 1)
    }
  }
  onCloseCollegeDiv(collegeId: number) {

    let batchData = this.SelectedCollegeDataList.filter(x => x.collegeId == collegeId);
    for (let i = 0; i < batchData[0].Batches.length; i++) {
      let selectedItem = this.collegeBatchSelect.selectedItems.findIndex(item => item.id === batchData[0].Batches[i].BatchId);
      if (selectedItem != -1) {
        this.collegeBatchSelect.selectedItems.splice(selectedItem, 1)
      }
      this.totalstudent = this.totalstudent - batchData[0].Batches[i].totalStudent;
    }
    this.SelectedCollegeDataList.forEach((element, index) => {
      if (element.collegeId == collegeId)
        this.SelectedCollegeDataList[index].Batches.splice(0, this.SelectedCollegeDataList[index].Batches.length);
    });


  }

  onDeSelectAllCollegeBatch() {
    this.totalstudent = 0;
    const parentUl = document.querySelector(
      `.select_batch_list_${this.collegeId}`
    );
    for (var i = 0; i < this.finalSelectedBaches.length; i++) {
      this.finalSelectedBaches[i].batchs = [];
    }
    const element = this.elementRef.nativeElement.querySelector(`.select_college_list_${this.collegeId}`);
    element.remove();
    if (parentUl) {
      while (parentUl.firstChild) {
        parentUl.removeChild(parentUl.firstChild);
      }
    }
  }
  filterArrayList: any = []
  search(event) {

    if (event.target.value == '' || event.key == 'Enter') {
      this.spinner.show();
      this.SearchCollege = event.target.value;
      const objData = {
        Filter: this.SearchCollege,
      };
      const apiUrl = this.apiUrl.apiUrl.college.GetCollegeListForExam;
      this.commonService
        .doPost(apiUrl, objData)
        .pipe()
        .subscribe({
          next: async (data) => {
            this.filterArrayList = [];
            if (data && data.data && data.data.length > 0) {

              this.filterArrayList = data.data;
              for (let index = 0; index < this.filterArrayList.length; index++) {
                if (this.SelectedCollegeId.includes(this.filterArrayList[index].id)) {
                  this.filterArrayList[index].checked = true;
                }

              }
              this.collegeNotFound = false;
            }
            else {
              this.collegeNotFound = true;
            }

          },
          error: (err) => {
          }
        });
      this.spinner.hide();
    }
  }

  GetCutOff(value) {
    this.CutOff = Number.parseInt(value);
    this.cutoffCheck = false;
    if (
      this.CutOff == 0 ||
      this.CutOff == undefined ||
      Number.isNaN(this.CutOff) ||
      this.CutOff == null ||
      this.CutOff == ''
    ) {
      this.toastr.error('Passing marks cannot be less than or equal to 0');
      this.cutoffCheck = false;
      return;
    }
    if (this.CutOff >= this.totalQuestions) {
      this.toastr.error(
        'Passing marks cannot be more than or equal to total question marks'
      );
      this.cutoffCheck = false;
      return;
    }
    this.cutoffCheck = true;
  }

  saveTest() {
    const model = this.firstFormGroup.value;

    this.batchIds = [];
    const formattedStartTime = moment(model.StartTime, 'hh:mm A').format(
      'hh:mm A'
    );

    const formattedEndTime = moment(model.EndTime, 'hh:mm A').format('hh:mm A');

    var dateSelected = new Date(this.firstFormGroup.value.Date);
    this.formattedDate = dateSelected.toDateString();

    // Create moments for start and end times with the selected date
    const startTimeMoment = moment(
      `${this.formattedDate} ${formattedStartTime}`,
      'ddd MMM DD YYYY hh:mm A'
    );

    const endTimeMoment = moment(
      `${this.formattedDate} ${formattedEndTime}`,
      'ddd MMM DD YYYY hh:mm A'
    );

    // Construct the desired string format 'YYYY-MM-DDTHH:mm:ss.sssZ'
    const startTimeFormatted = startTimeMoment.format(
      'YYYY-MM-DDTHH:mm:ss.SSS'
    );
    const endTimeFormatted = endTimeMoment.format('YYYY-MM-DDTHH:mm:ss.SSS');

    // Add the 'Z' at the end to indicate UTC timezone
    const startTime = startTimeFormatted + 'Z';
    const endTime = endTimeFormatted + 'Z';

    // Calculate test Duration In Minutes
    var Hours = Number.parseInt(this.firstFormGroup.value.Hours) * 60;
    var Minutes = Number.parseInt(this.firstFormGroup.value.Minutes);
    this.testDuration = Hours + Minutes;

    for (let index = 0; index < this.selectedQuestionSetItems.length; index++) {
      this.questionSetArray.push({
        QuestionSetId: this.selectedQuestionSetItems[index].questionSetId,
        NoOfQuestion:
          this.secondFormGroup.value.questionSet[index].numberOfQuestion,
      });
    }
    for (let i = 0; i < this.SelectedCollegeDataList.length; i++) {
      for (let j = 0; j < this.SelectedCollegeDataList[i].Batches.length; j++) {
        if (!(this.ExamSelectedBatches.filter(x => x.batchId == this.SelectedCollegeDataList[i].Batches[j].BatchId).length > 0)) {
          this.ExamSelectedBatches.push({ batchId: this.SelectedCollegeDataList[i].Batches[j].BatchId });
        }
      }
    }

    model.Date = this.convertToIST(model.Date);
    var SaveTestModel = {
      ExamId: Number.parseInt(this.EditId),
      ExamName: model.TestName,
      ExamDate: model.Date,
      StartTime: startTime,
      EndTime: endTime,
      DurationInMins: Number.parseInt(this.testDuration),
      TotalQuestion: this.totalQuestions,
      CutOff: this.CutOff,
      CreatedBy: 0,
      CompanyId: 0,
      Batches: this.ExamSelectedBatches,
      QuestionSet: this.questionSetArray,
    };
    const modalRef = this.modalService.open(SaveTestDialogComponent, { centered: true, backdrop: 'static', keyboard: false });
    this.SaveTestObj = {
      testId: this.EditId,
      testName: model.TestName
    }

    modalRef.componentInstance.saveTestObj = this.SaveTestObj;
    modalRef.result.then((result) => {
      if (result === 'SaveTest') {
        this.spinner.show();
        const apiUrl = this.apiUrl.apiUrl.test.SaveTest;
        this.commonService
          .doPost(apiUrl, SaveTestModel)
          .pipe()
          .subscribe({
            next: (data) => {
              this.spinner.hide();
              if (data && data.data && data.data.length > 0) {
                for (
                  let index = 0;
                  index < this.finalSelectedBaches.length;
                  index++
                ) {
                  const element = this.finalSelectedBaches[index];
                  for (let index = 0; index < element.batchs.length; index++) {
                    const ele = element.batchs[index];
                    this.batchIds.push(ele.id);
                  }
                }
              }
              if (data.success && this.totalstudent != 0) {
                this.toastr.success(data.message);
                this.route.navigate(['exam']);
              } else {

                this.toastr.error('Some error occur adding exam');
              }
            },
            error: (err) => {
              this.spinner.hide();
              //console.log('getCollegeList-Error', err);
            }
          });
      }
    }).catch((error) => {
    });

  }

  // Edit Test Functionalities Below
  async GetTestData(TestId: any) {
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.test.EditTestData.replace("{examId}", TestId.toString());
    await this.commonService.doGet(apiUrl).pipe().subscribe({
      next: async (res) => {
        this.EditExamData = res.data;
        const startTime = this.extractTime(this.EditExamData.startTime);
        const endTime = this.extractTime(this.EditExamData.endTime);
        this.selectedQuestionSetItems = this.EditExamData.questionSet;
        this.totalQuestions = this.EditExamData.totalQuestion;
        this.CutOff = this.EditExamData.cutOff;
        const Duration = this.EditExamData.durationInMins;
        const hours = Math.floor(Duration / 60);
        const Minutes = Duration % 60;
        let TotalBindCOllege: number = 0;
        let CollegeSelectFlag: boolean = false;
        this.totalQuestionCheck = true;
        this.cutoffCheck = true;
        // // For Patching the Selected Colleges  (Third Form)
        var SelectedCollegeId: any = [];
        var SelectedCollegeBatch: any = [];

        for (let i = 0; i < this.EditExamData.batch.length; i++) {
          SelectedCollegeId.push(this.EditExamData.batch[i].collegeId);
        }
        for (let i = 0; i < this.collegeList.length; i++) {
          const college = this.collegeList[i];
          CollegeSelectFlag = SelectedCollegeId.includes(college.id);
          if (CollegeSelectFlag == true) {
            this.SelectedCollegeId.push(college.id);
            TotalBindCOllege = TotalBindCOllege + 1;
            college.checked = true;
          }
          else {
            college.checked = false;
          }
        }


        this.thirdFormGroup.setValue({
          TotalCollge: TotalBindCOllege
        });


        await this.bindSelectedCollege();
        for (let i = 0; i < this.selectedCollege.length; i++) {
          this.collegeId = this.selectedCollege[i].id;
          let CollegeData = this.collegeList[this.collegeList.findIndex(x => x.id === Number(this.selectedCollege[i].id))]
          let collegedata = this.SelectedCollegeDataList.filter(x => x.collegeId == this.collegeId);
          if (collegedata.length > 0)
            console.log("");
          else {
            let newCollegeDivData = {
              collegeName: CollegeData.collegeName,
              city: CollegeData.city,
              state: CollegeData.state,
              collegeUrl: CollegeData.collegeUrl
            }
            this.SelectedCollegeDataList.push({ collegeId: this.collegeId, CollegeData: newCollegeDivData, Batches: [] })
          }

          if (this.SelectedCollegeDataList.length > 0) {

            let CollegeBatchData = this.SelectedCollegeDataList.filter(x => x.collegeId == this.collegeId);
            var allSelectedBatch = this.EditExamData.batch.filter(x => x.collegeId == this.collegeId)

            for (let j = 0; j < allSelectedBatch.length; j++) {

              if (CollegeBatchData && CollegeBatchData[0].Batches.length > 0) {
                let checkBatchIsExist = CollegeBatchData[0].Batches.filter(x => x.BatchId == allSelectedBatch[j].testBatchId)
                if (checkBatchIsExist.length == 0) {

                  CollegeBatchData[0].Batches.push({ BatchId: allSelectedBatch[j].examBatchId, BatchName: allSelectedBatch[j].batchName + "(" + allSelectedBatch[j].totalStudents + ")", totalStudent: allSelectedBatch[j].totalStudents })
                }
              }
              else {
                CollegeBatchData[0].Batches.push({ BatchId: allSelectedBatch[j].examBatchId, BatchName: allSelectedBatch[j].batchName + "(" + allSelectedBatch[j].totalStudents + ")", totalStudent: allSelectedBatch[j].totalStudents })
              }
              this.collegeBatchSelect.selectedItems.push({ id: allSelectedBatch[j].examBatchId, text: allSelectedBatch[j].batchName + allSelectedBatch[j].totalStudents })
              this.totalstudent = this.totalstudent + allSelectedBatch[j].totalStudents;
            }
          }
          this.spinner.hide();


        }
        this.updateCutOffValue(this.EditExamData.cutOff);

        let IndexOfSelectedQuestionSet = [] as any;
        if (this.selectedQuestionSetItems.length > 0) {
          this.selectedQuestionSetItems.forEach(item => {

            // Initialize numberOfQuestion form control for each question set
            const index = this.selectedQuestionSetItems.findIndex(selectedItem => selectedItem.examQuestionSet === item.examQuestionSet);
            if (index >= 0 && !IndexOfSelectedQuestionSet.includes(index)) {
              IndexOfSelectedQuestionSet.push(index)
              this.yourDropdown.selectedItems.push({ questionSetId: item.questionSetId, examQuestionSet: item.examQuestionSet })
              this.onItemSelectQuestionSet(item);
              const control: any = this.secondFormGroup.get('questionSet') as FormArray;
              control.at(index).get('numberOfQuestion').setValue(item.noOfQuestion);
            }
          });
        }
        this.firstFormGroup.patchValue({
          TestName: this.EditExamData.examName,
          Date: new Date(this.EditExamData.examDate),
          StartTime: startTime,
          EndTime: endTime,
          Hours: hours,
          Minutes: Minutes,
        });
        if (formatDate(new Date(this.EditExamData.examDate), 'dd/MM/yyyy', 'en') == formatDate(new Date(), 'dd/MM/yyyy', 'en')) {
          this.examDate = true;
        }

        const utcDate1: any = new Date(this.EditExamData.startTime);
        const utcDate2: any = new Date(this.EditExamData.endTime);
        this.testDuration = utcDate2 - utcDate1;
        this.MaxDurationExanInMilliSecond = this.testDuration;
      }
    });


  }

  convertToIST(utcTime: string): string {
    const utcDateTime = new Date(utcTime);

    // Add 5 hours and 30 minutes to convert to IST
    const istDateTime = new Date(utcDateTime.getTime() + (5 * 60 + 30) * 60 * 1000);

    // Convert to ISO string format
    return istDateTime.toISOString();
  }

  optionCheck(index) {
    this.optionCheckItem = this.secondFormGroup.get('questionSet') as FormArray;
    const formGroup = this.optionCheckItem.controls[index] as FormGroup;
    return formGroup;
  }

  extractTime(dateTimeString: string): string {
    const time = new Date(dateTimeString).toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    });
    return time;
  }

  updateCutOffValue(newCutOff: string) {
    this.cutOffInput.nativeElement.value = newCutOff;
  }
  deleteAllBatches() {
    this.SelectedCollegeDataList = [];
    this.fourthFormGroup.setValue({
      CollegeId: ''
    });
    this.collegeBatchSelect.selectedItems.splice(0, this.collegeBatchSelect.selectedItems.length);
    this.totalstudent = 0;
  }


  havingBatches() {
    let havingBatchFlag: boolean = false;
    for (let i = 0; i < this.SelectedCollegeDataList.length; i++) {
      if (this.SelectedCollegeDataList[i].Batches.length > 0) {
        havingBatchFlag = true;
        break;
      }
      else {
        havingBatchFlag = false;
      }
    }
    return havingBatchFlag;
  }


  formatTime(date: Date): string {

    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  validateDateTime() {
    const currentDate = new Date();
    if (!this.selectedDate || !this.selectedTime) {
      return;
    }

    const selectedDateTime = new Date(this.selectedDate1);
    selectedDateTime.setHours(this.selectedTime.getHours(), this.selectedTime.getMinutes());

    if (selectedDateTime < currentDate) {
    } else {
    }
  }
  onDateValueChange(e: any) {
    this.currentDate = formatDate(new Date(), 'dd/MM/yyyy', 'en');
    const examDate1 = formatDate(e.value, 'dd/MM/yyyy', 'en');
    this.currentDate == examDate1 ? this.examDate = true : this.examDate = false;
    if (this.examDate) {
      this.firstFormGroup.patchValue({
        StartTime: "",
        EndTime: ""
      });
    }

  }

  getStudentList() {
    const modalRef = this.modalService.open(StudentListComponent, { centered: true, backdrop: 'static', keyboard: false, windowClass: 'full-width-model' });
    modalRef.componentInstance.SelectedCollegeDataList = this.SelectedCollegeDataList;
  }

}







